import MainLayout from 'components/templates/MainLayout'
import { useSelector } from 'react-redux'
import { Navigate, useLocation } from 'react-router-dom'
import routes from 'routes'
import { ROLES } from 'utils/config'

const HomeView = () => {
  const { state } = useLocation()
  const { userInfo } = useSelector((s) => s.auth)

  if (userInfo.role === ROLES.user.value) return <Navigate to={routes.user} state={state} />
  if (userInfo.role === ROLES.admin.value) return <Navigate to={routes.adminProjects} state={state} />

  return (
    <MainLayout>
      <p>HomeView</p>
    </MainLayout>
  )
}

export default HomeView
